import React, { useEffect, useState, useContext } from 'react';
import { Table, Row, Col } from 'antd';
import * as Setting from '../../utils/AuthUtils';
import AddTournament from '../../components/AddTournament';
import { generateTournamentCols } from '../../utils/DataUtils';
import { MeContext } from '../../context';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

function TournamentsList(props) {
    const [hasRights, setHasRights] = useState({isAdmin: false, isReferral: false});
    const me = useContext(MeContext);
    const { t } = useTranslation();

    useEffect(() => {
      const isAd = (me && me.payLoad ? me.payLoad.isAdmin : false)
      const isRef = Setting.isReferral(me && me.payLoad ? me.payLoad : {}); 
      setHasRights({isAdmin: isAd, isReferral: isRef});
      }, [me])
      
      return (
        <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
          <h1>
            {t('tournaments.title').toUpperCase()}
          </h1>
          { Setting.isLoggedIn() && (hasRights.isAdmin || hasRights.isReferral) &&
            <Row><Col span={24}><AddTournament /></Col></Row>
          }
          <Table
              style={{ marginTop: '16px' }}
              rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
              size="small"
              columns={generateTournamentCols(t)} 
              dataSource={(props.tournaments && props.tournaments.payLoad ? props.tournaments.payLoad : [])} 
              pagination={{ pageSize: 20 }} 
              loading={props.pending}/>
        </motion.div>
    );
}

export default TournamentsList;